import {
  Button,
  Col,
  DatePicker,
  Menu,
  Modal,
  Row,
  Space,
  Table,
  Typography
} from 'antd';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import DropdownAction from '@root/modules/Warehouse/Shared/Actions/DropdownAction';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import {
  CloseOutlined,
  MailOutlined,
  PaperClipOutlined
} from '@ant-design/icons';
import { Editor } from '@toast-ui/react-editor';
import SearchBox from '../../Forwarding/components/SearchBox';
import forwardingService from '../services/forwarding';
import { formatDateTime } from '@root/utils/helpers/formatDate';
const SellerMessage = () => {
  const [fileList, setFileList] = useState<any[]>([]);
  const [date, setDate] = useState<[string, string]>();
  const handleUploadChange = (e: any) => {
    if (e.target.files[0]) {
      setFileList([...fileList, e.target.files[0]]);
    }
  };
  const [search, setSearch] = useState('');

  const handleFileDelete = (fileName: string) => {
    setFileList(fileList.filter((file) => file.name !== fileName));
  };
  console.log(date);
  const [page, setPage] = useState(1);
  const [messageList, setMessageList] = useState();
  const [total, setTotal] = useState(0);
  const fetchData = async () => {
    const res = await forwardingService.getMessageList(
      page,
      search,
      date?.[0],
      date?.[1]
    );
    setTotal(res.count);
    const data = res.data;
    setMessageList(
      data.map((item: any) => ({
        ...item,
        name: item.forwarding.name,
        country: item.forwarding.country
      }))
    );
  };

  const onUploadImage = async (blob: File, callback: any) => {
    const url = await forwardingService.uploadFile([blob]);
    console.log(url);
    callback(url.data.attachments[0].url, '');
    return false;
  };

  useEffect(() => {
    fetchData();
  }, [page, search, date]);
  const [content, setContent] = useState('');
  console.log(messageList);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const breadcrumbList = [
    { url: '', tittle: '포워딩 업체 문의' },
    { url: '', tittle: '메세지 목록' }
  ];
  const columns = [
    {
      title: 'No',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: '업체명',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '국가',
      dataIndex: 'country',
      key: 'country'
    },
    {
      title: '견적서 연동 유무',
      dataIndex: 'hasQuotation',
      key: 'hasQuotation',
      render: (hasQuotation: boolean) => {
        return hasQuotation ? 'O    ' : 'X';
      }
    },
    {
      title: '대화 상태',
      dataIndex: 'cancelStatusText',
      key: 'cancelStatus'
      // render: (cancelStatus: string) => {
      //   return cancelStatus === 'SellerCancel' ? '셀러 취소 제안' : '진행중';
      // }
    },
    {
      title: '진행 상태',
      dataIndex: 'status',
      key: 'status'
    },
    {
      title: '첫 메세지 일시',
      dataIndex: 'startedAt',
      key: 'startedAt',
      render: (startedAt: Date) => {
        return formatDateTime(new Date(startedAt));
      }
    },

    {
      title: '마지막 메세지 일시',
      dataIndex: 'endedAt',
      key: 'endedAt'
    }
  ];

  const history = useHistory();
  console.log(search, date);
  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <div className="custom-dp" style={{ display: 'flex', gap: 2 }}>
          <Space
            direction="vertical"
            size={12}
            className="dataPicker stylePlace"
          >
            <DatePicker.RangePicker
              placeholder={['YYYY.MM.DD', 'YYYY.MM.DD']}
              onChange={(date: any, dateString: [string, string]) => {
                setDate(dateString);
              }}
              // defaultValue={[
              //   moment(moment(), dateFormat),
              //   moment(moment(), dateFormat),
              // ]}
              format={'YYYY-MM-DD'}
            />
          </Space>

          <SearchBox placeholder="업체명 검색" onChange={setSearch} />
        </div>
        <div style={{ marginTop: 20, backgroundColor: 'white' }}>
          <Table
            className="busk-table"
            pagination={{
              pageSize: 10,
              total: total,
              onChange: (newPage) => {
                setPage(newPage);
              }
            }}
            onRow={(record) => {
              return {
                onClick: () => {
                  history.push(`/admin/seller/message/${record.id}`);
                }
              };
            }}
            // loading={loading}
            columns={columns}
            dataSource={messageList}
            // dataSource={[{ test: 1 }]}
          />
          <Modal
            width={'auto'}
            closeIcon={<CloseOutlined />}
            onCancel={() => setIsModalOpen(false)}
            title="메세지 작성"
            className="forwarding-modal"
            visible={isModalOpen}
            footer={[
              <button disabled={!!!content} className="forwarding-btn">
                메세지 전송
              </button>
            ]}
            centered
          >
            <Editor
              initialEditType="wysiwyg"
              hooks={{
                addImageBlobHook: (blob, callback) =>
                  onUploadImage(blob as File, callback)
              }}
              onChange={(content) => setContent(content)}
              hideModeSwitch={true}
            />
            <div className="file-wrap">
              <label htmlFor="file" className="file-btn">
                <span>파일</span>
                <PaperClipOutlined width={16} height={16} />
              </label>
              <input
                onChange={handleUploadChange}
                type="file"
                id="file"
                style={{ display: 'none' }}
              />
              <div style={{ display: 'flex', gap: 12, overflowX: 'auto' }}>
                {fileList.map((file, index) => (
                  <Button className="file-name" key={index}>
                    <span>{file.name}</span>
                    <CloseOutlined
                      onClick={() => handleFileDelete(file.name)}
                    />
                  </Button>
                ))}
              </div>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default SellerMessage;
